/* eslint-disable camelcase */
import { defineRule, configure } from 'vee-validate';

const urlFixRule = (url) => {
	url = encodeURI(url);
	if (url) {
		const ws = url.indexOf(' ') >= 0;

		if (!ws) {
			const res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
			return (res !== null);
		}
	}
	return false;
};

// VEE VALIDATE 4
defineRule('required', (value) => {
	if (!value || !value.length) {
		return 'El campo es obligatorio';
	}
	return true;
});

defineRule('email', (value) => {
	if (!value || !value.length) return true;
	if (!/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/i.test(value)) {
		return 'Introduce un email válido';
	}
	return true;
});

defineRule('min', (value, [limit]) => {
	if (!value || !value.length) return true;
	if (value.length < limit) {
		return `El campo no debe tener menos de ${limit} caracteres`;
	}
	return true;
});

defineRule('max', (value, [limit]) => {
	if (!value || !value.length) return true;
	if (value.length > limit) {
		return `El campo no debe superar los ${limit} caracteres`;
	}
	return true;
});

defineRule('confirmed', (value, [target]) => {
	if (value === target) {
		return true;
	}
	return 'El campo no es correcto';
});

defineRule('url', (value) => {
	if (!value || !value.length) return true;
	if (!urlFixRule(value)) {
		return 'El campo no es una url valida';
	}
	return true;
});

configure({
	generateMessage: ctx => `El campo ${ctx.field} no es válido`,
});

// Export a validate function for backward compatibility
// eslint-disable-next-line no-unused-vars
export default function validate(value, rules) {
	// Simple compat shim - the actual validation is done by defineRule
	return { valid: true };
}
